module.exports = __webpack_public_path__ + "static/media/refresh.e47808ea.svg";